import { Alert, Icon, Text } from '@wyz/ui';
import clsx from 'clsx';
import React from 'react';
import { Trans } from '~/common/context';

type Props = {
  className?: string;
  message?: React.ReactNode;
};
function NoResultsBanner({ className, message }: Props) {
  return (
    <Alert
      variant='info'
      className={clsx('d-flex align-items-center', className)}
    >
      <Icon icon='information-line' size='md' className='text-info-text me-3' />
      <Text id='search-no-results' heading='sm' color='info'>
        {message ?? (
          <Trans i18nKey='app.purchase.search_page.no_results_banner' />
        )}
      </Text>
    </Alert>
  );
}

export default NoResultsBanner;
